import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogOutModel } from 'src/app/models/common';

@Component({
  selector: 'app-ext-header',
  templateUrl: './ext-header.component.html',
  styleUrls: ['./ext-header.component.scss']
})
export class ExtHeaderComponent implements OnInit {
  moduleUrl;
  requestId;
  routerLinkUrl;
  request;
  module;
  userDetails;
  username;
  currentDate;

  isChecked: number = 0;

  @ViewChild('links') links;
  constructor(private router: Router, private renderer: Renderer2, private modalService: NgbModal, private userService: UserService) { }

  ngOnInit() {
    this.userService.getUserData(localStorage.getItem('id')).subscribe(result => {
      this.userService.setUserDetails(result);
      this.userDetails = result;
      this.username = result['username'];
    });
    this.currentDate = new Date();

    // setTimeout(() => {
    //   this.moduleUrl = this.router.url.split('application-ext')[0];
    //   this.requestId = this.router.url.split('application-ext')[1].split('/')[1];
    //   this.module = this.router.url.split('/')[2];
    //   this.routerLinkUrl = this.moduleUrl + 'application-ext/' + this.requestId;
    //   switch (this.module) {
    //     case 'ist':
    //       this.extService.getIstRequest(this.requestId).subscribe((result) => {
    //         this.request = result;
    //       })
    //       break;
    //     case 'grants':
    //       this.extService.getGrantsRequest(this.requestId).subscribe((result) => {
    //         this.request = result;
    //       })
    //       break;
    //     case 'eap':
    //       this.extService.getEapRequest(this.requestId).subscribe((result) => {
    //         this.request = result;
    //       })
    //       break;
    //   }
    // });
  }

  ngOnChanges() {
  }

  changeTab(url, request) {
    this.router.navigateByUrl(url + '/' + request);
  }

 

  checkOnCallbackOperationhide() {
    this.isChecked = 0;
  }
  checkOnCallbackOperationOn() {
    if (this.isChecked === 0) {
      this.isChecked = 1;
    }
  }
  checkOnCallbackOperationOff() {
    this.isChecked = 2;
  }

  onCallbackOperation(operation) {
    operation.callback();
  }

  save() {
    this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Save Request', content: { description: 'The Request ID 1234 has been Saved.' } } })
  }

 

  logout(LogoutReason: string = '') {

    let browser = this.userService.detectBrowserName();
    let user = this.userService.getUserDetais();
    let model = new LogOutModel();
    model.Browser = browser.name;
    model.Reason = LogoutReason;
    model.Version = browser.version;
    model.UserId= user.ID;
    
    this.userService.userLogout(model).subscribe(result => {
      if (result.Status == 0) {
        this.router.navigate(['login', { skipLocationChange: true }]);
        localStorage.clear();
        window.location.reload();
      }
    });
  }


}
